export default "__VITE_PUBLIC_ASSET__23d89d56__"